import { formatTimestamp } from 'shared/formatters';
import { getPrinter } from 'shared/printerManager';
import { addPrintLogo, getTickets, sendPrintJob } from './usePrintTickets';
import { useStoreGetTransaction } from './useStoreGetTransaction';

const formatLineItem = ({ name, price }) => {
  //48
  //32
  const lineLength = 48;
  let final_name = '';
  const priceLength = price.length;
  const nameCharacterLength = 35 - priceLength;

  if (nameCharacterLength < name.length) {
    final_name = `${name.substring(0, nameCharacterLength - 5)}..`.padEnd(
      lineLength - priceLength,
      ' '
    );
  } else {
    final_name = name.padEnd(lineLength - priceLength, ' ');
  }

  return `${final_name}${price}`;
};

export const usePrintReceipt = () => {
  const { storeLastTransaction, getLastTransaction } = useStoreGetTransaction();

  const printTransaction = async ({ transaction, setIsPrinting }) => {
    if (setIsPrinting) setIsPrinting(true);

    storeLastTransaction(transaction);

    const prn = getPrinter();
    if (!prn) {
      alert('Not connected to printer');
      if (setIsPrinting) setIsPrinting(false);
      return;
    }

    const tickets = getTickets(transaction);

    try {
      prn.addTextAlign(prn.ALIGN_CENTER);
      prn.addTextSmooth(true);
      addPrintLogo(prn);
      prn.addFeedLine(1);
      prn.addText(transaction?.event?.name);
      prn.addFeedLine(1);
      prn.addText('@');
      prn.addFeedLine(1);
      prn.addText(transaction?.track?.name);

      prn.addTextAlign(prn.ALIGN_LEFT);
      prn.addFeedLine(1);
      prn.addText('------------------------------------------------');
      prn.addFeedLine(1);

      tickets.forEach((ticket) => {
        prn.addText(formatLineItem(ticket));
        prn.addFeedLine(1);
      });

      prn.addText('------------------------------------------------');
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({ name: '***TOTAL', price: transaction.total })
      );
      prn.addFeedLine(1);
      prn.addText('------------------------------------------------');
      prn.addText(
        formatLineItem({
          name: '***PAYMENT METHOD',
          price: transaction.payment_method?.toUpperCase(),
        })
      );
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({
          name: '***ORDER #',
          price: transaction.id?.toString(),
        })
      );
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({
          name: '***SOLD BY',
          price: transaction.register
            ? transaction.register.toUpperCase()
            : 'APP',
        })
      );
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({
          name: '***DELIVERY METHOD',
          price: transaction.delivery_method?.toUpperCase(),
        })
      );
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({
          name: '***ORDER SOURCE',
          price: transaction.order_source?.toUpperCase(),
        })
      );
      prn.addFeedLine(1);
      prn.addText(
        formatLineItem({
          name: '***TIMESTAMP',
          price: formatTimestamp(
            Number(transaction.purchase_date),
            'MMM DD - YYYY h:mm A',
            true
          ),
        })
      );

      prn.addFeedLine(5);
      prn.addCut(prn.CUT_FEED);
    } catch (error) {
      alert(error.message || error);
    }

    await sendPrintJob(prn);

    if (setIsPrinting) setIsPrinting(false);
  };

  const reprintLastReceipt = async (setIsPrinting) => {
    const transaction = getLastTransaction();
    if (!transaction) {
      alert('No last transaction found to reprint.');
      return;
    }

    await printTransaction({ transaction, setIsPrinting });
  };

  return {
    printReceipt: printTransaction,
    reprintLastReceipt,
  };
};
